import Spinner from "../../components/Tools/spinner";
import { useState, useRef } from "react";
import { useSelector } from "react-redux";
import SubHeader from "../../components/Subheader/Subheader";
import CustomBreadcrumbs from "../../components/Tools/Breadcumbs";
import { exportSubActivityDetailedPPAOverviewReport } from "../../helper/Api";
import MainFilter from "../../components/Tools/MainFilter";
import { toast } from "react-toastify";
import DashboardFilter from "../Dashboard/components/DashboardFilter";
import moment from "moment";

export default function ConsolidarePpa() {
    const [loading, setLoading] = useState(false);
    const { authData, financialYears } = useSelector((state) => state.authData);
    const [open, setOpen] = useState(false);
    const fy_list = financialYears.payload.fy_list;
    const fyIdRef = useRef(localStorage.getItem("globalDateId"));
    const handlePageTrigger = () => {
        fyIdRef.current = localStorage.getItem("globalDateId");
      };
    const [activeCard, setActiveCard] = useState([]);
    const [activeSchemeTab, setActiveSchemeTab] = useState({});
    const [openDepartmentCards, setOpenDepartmentCards] = useState({});
    const [openSchemeCards, setOpenSchemeCards] = useState({});
    const [departments, setDepartments] = useState([]);
    const [filterPayload, setFilterPayload] = useState({
      fromDate: "",
      toDate: ""
  });
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const handleInput = async (e) => {
        const {name, value} = e.target;
        setFilterPayload((prev) => ({
            ...prev, [name]: value
        }));
    }
    const calculateExpense = (tierFigures) => {
        return tierFigures?.reduce(
            (total, tier) => total + Number(tier.expenses),
            0
        );
    };
    const calculateSchemeExpense = (scheme) => {
        let expense = 0;
        scheme.sub_head_list.forEach((subhead) => {
          // expense += calculateExpense(subhead.tierFigures);
          expense += 0;
        });
        return expense;
      };

    const getDeptKey = (dept, deptIndex) =>
      dept?.department_id ??
      dept?.departmentId ??
      dept?.id ??
      `${deptIndex}_${dept?.department_name ?? "dept"}`;

    const getSchemeUniq = (scheme, schemeIndex) =>
      scheme?.id ??
      scheme?.scheme_id ??
      scheme?.schemeId ??
      scheme?.code ??
      schemeIndex;

    const getSchemeKey = (dept, deptIndex, scheme, schemeIndex) =>
      `${getDeptKey(dept, deptIndex)}_${getSchemeUniq(scheme, schemeIndex)}`;

    const areAllCardsOpen = (() => {
      if (!departments?.length) return false;
      for (let di = 0; di < departments.length; di++) {
        const dept = departments[di];
        const deptKey = getDeptKey(dept, di);
        if (!openDepartmentCards[deptKey]) return false;
        const schemes = dept?.schemes ?? [];
        for (let si = 0; si < schemes.length; si++) {
          const schemeKey = getSchemeKey(dept, di, schemes[si], si);
          if (!openSchemeCards[schemeKey]) return false;
        }
      }
      return true;
    })();

    const handleToggleAll = () => {
      const nextOpen = !areAllCardsOpen;
      if (!nextOpen) {
        setOpenDepartmentCards({});
        setOpenSchemeCards({});
        return;
      }

      const nextDeptOpen = {};
      const nextSchemeOpen = {};
      departments.forEach((dept, di) => {
        const deptKey = getDeptKey(dept, di);
        nextDeptOpen[deptKey] = true;
        (dept?.schemes ?? []).forEach((scheme, si) => {
          nextSchemeOpen[getSchemeKey(dept, di, scheme, si)] = true;
        });
      });
      setOpenDepartmentCards(nextDeptOpen);
      setOpenSchemeCards(nextSchemeOpen);
    };

    const mainCardSwitch = (val1, val2, val3, detailObj) => {
        setActiveCard((prev) => {
          let updated = [...prev];
          // Remove val2 and val3 if present
          updated = updated.filter((item) => item !== val2 && item !== val3);
          // Add val1 if not already present
          if (!updated.includes(val1)) {
            updated.unshift(val1); // Add at the beginning
          }
          return updated;
        });
      };

    const handleFilterClick = async () => {
      setOpen(false);
      try {
        setLoading(true);
        const response = await exportSubActivityDetailedPPAOverviewReport(authData.user.department_details.id, filterPayload.fromDate, filterPayload.toDate);
        if (response.data.status) {
          setDepartments(response.data.result);
        } else {
          toast.error(response.data.error, {
            position: toast.POSITION.TOP_CENTER
          });
        }
      } catch (error) {
        toast.error('Something went wrong!', {
          position: toast.POSITION.TOP_CENTER
        });
        setLoading(false);
      }
      finally {
        setLoading(false);
      }
  };

  const handleFilterRemove = async (name) => {
      const newPayload = {
      ...filterPayload,
      [name]: "",
    };
    setFilterPayload(newPayload);
    handleFilterClick();
  }

    return (
        <div>
            {loading && <Spinner />}
            <SubHeader fy_list={fy_list} handlePageTrigger={handlePageTrigger}/>
            <div className="row" style={{ padding: "10px 16px" }}>
                <div className="col-md-6">
                    <h4 style={{ color: "#28326f", margin:0}}>Consolidate PPA Report</h4>
                    <CustomBreadcrumbs linksArray={[]} title="Consolidate PPA Report"/>
                </div>
                <div className="col-md-6">
                  <div className="m-0 p-0 d-flex gap-2" style={{ width: "auto", float: "right" }}>
                    <button className="navigation_button">Export to Excel</button>
                    <div className="d-flex align-items-center gap-2 bg-white border-Prime-100 px-3 py-2 rounded-3">
                      <span className="fs-12px text-secondary-100 fw-500">
                        {areAllCardsOpen ? "Close all" : "Open all"}
                      </span>
                      <div className="form-check form-switch m-0">
                        <input
                          className="form-check-input cursor-pointer"
                          type="checkbox"
                          role="switch"
                          checked={areAllCardsOpen}
                          onChange={handleToggleAll}
                          aria-label={areAllCardsOpen ? "Close all cards" : "Open all cards"}
                        />
                      </div>
                    </div>
                  </div>
                </div>
            </div>

            <DashboardFilter 
            openFilterModal={setOpen} 
            filterPayload={filterPayload} 
            handleFilterRemove={handleFilterRemove} />
            
            <div className="row">
              <div
                className="px-3 col-12 d-flex flex-column gap-3 overflow-y-auto overflow-x-hidden"
                style={{ height: "100vh" }}
              >
                {departments.map((e, index) => {
                  const deptKey = getDeptKey(e, index);
                  const isDeptOpen = !!openDepartmentCards[deptKey];

                  return (
                  <div
                    className="bg-white border-Prime-100 my-2 p-0"
                    style={{ borderRadius: "8px" }}
                    key={deptKey}
                  >
                    <div
                      className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden"
                      style={{ borderRadius: "8px 8px 0 0" }}
                    >
                      {/* ======================card header================== */}
                      <span
                        className="fs-14px white-space-nowrap overflow-x-hidden d-flex justify-content-between align-items-center gap-2 p-0 m-0 w-100"
                        style={{ width: "95%", fontStyle: "italic" }}
                      >
                        {/* =======================card header====================== */}
                        <span
                          className="fs-14px white-space-nowrap overflow-x-hidden"
                          style={{ width: "95%", fontStyle: "italic" }}
                        >
                          <span className="fw-500 text-secondary-100">
                            {e.department_name}
                          </span>
                        </span>
                      </span>
                      <button
                        type="button"
                        className="border-0 bg-transparent p-0 m-0 d-flex align-items-center"
                        onClick={() =>
                          setOpenDepartmentCards((prev) => ({
                            ...prev,
                            [deptKey]: !prev[deptKey],
                          }))
                        }
                        aria-label={isDeptOpen ? "Collapse department" : "Expand department"}
                      >
                        <i
                          className={`icon-keyboard_arrow_${
                            isDeptOpen ? "down" : "right"
                          } cursor-pointer fs-18px text-secondary-100`}
                        ></i>
                      </button>
                    </div>

                    {isDeptOpen ? (
                      <>
                        <div className="row py-2 px-3">
                          <div className="col-md-2"></div>
                          <div className="col-md-2">
                            <div className="light-green-div bg-success-20">
                              <span className="fw-500 fs-12px">
                                Prov. Budget {" "}
                                <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                                <br />
                                <span className="fs-18px text-success-100">
                                  {/* {e.provisional_budget.toLocaleString("en-IN")} */}
                                </span>
                              </span>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="light-green-div bg-success-20">
                              <span className="fw-500 fs-12px">
                                Released Budget FY{" "}
                                {e.financial_year}{" "}
                              </span>{" "}
                              <br />
                              <span className="fs-18px text-success-100">
                                {/* {e.budget.toLocaleString("en-IN")} */}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-2"></div>
                          <div className="col-md-2">
                            <div
                              className="light-green-div"
                              style={{ backgroundColor: "#28316f" }}
                            >
                              <span
                                className="fw-500 fs-12px"
                                style={{ color: "#ffffff" }}
                              >
                                Expense Budget FY{" "}
                                {e.financial_year}{" "}
                              </span>{" "}
                              <br />
                              <span className="fs-18px" style={{ color: "#ffffff" }}>
                                {/* {calculateSchemeExpense(e).toLocaleString("en-IN")} */}
                              </span>
                            </div>
                          </div>
                          <div className="col-md-2">
                            <div className="light-green-div bg-success-100">
                              <span
                                className="fw-500 fs-12px"
                                style={{ color: "#ffffff" }}
                              >
                                Balance FY{" "}
                                {e.financial_year}{" "}
                                <br />
                                <span className="fs-18px" style={{ color: "#ffffff" }}>
                                  {/* {(e.budget - calculateSchemeExpense(e)).toLocaleString(
                                    "en-IN"
                                  )} */}
                                </span>
                              </span>
                            </div>
                          </div>
                        </div>
                        {
                          e.schemes.map((scheme, schemeIndex) => {
                            const schemeKey = getSchemeKey(e, index, scheme, schemeIndex);
                            const isSchemeOpen = !!openSchemeCards[schemeKey];
                            const schemeName = scheme?.name;

                            return (
                              <div className="ppa_scheme_card bg-white m-1 p-0" key={schemeKey}>
                                {/* scheme details starts */}
                                <div className="bg-secondary-20 d-flex justify-content-between align-items-center p-1 transition overflow-hidden">
                                  {/* ======================card header================== */}
                                  <span
                                    className="fs-14px white-space-nowrap overflow-x-hidden d-flex justify-content-between align-items-center gap-2 p-0 m-0 w-100"
                                    style={{ width: "95%", fontStyle: "italic" }}
                                  >
                                    {/* =======================card header====================== */}
                                    <span
                                      className="fs-12px white-space-nowrap overflow-x-hidden"
                                      style={{ width: "95%", fontStyle: "italic" }}
                                    >
                                      <span className="fw-500 text-secondary-100">
                                        {schemeName}
                                      </span>
                                    </span>
                                  </span>
                                  <button
                                    type="button"
                                    className="border-0 bg-transparent p-0 m-0 d-flex align-items-center"
                                    onClick={() =>
                                      setOpenSchemeCards((prev) => ({
                                        ...prev,
                                        [schemeKey]: !prev[schemeKey],
                                      }))
                                    }
                                    aria-label={isSchemeOpen ? "Collapse scheme" : "Expand scheme"}
                                  >
                                    <i
                                      className={`icon-keyboard_arrow_${
                                        isSchemeOpen ? "down" : "right"
                                      } cursor-pointer fs-18px text-secondary-100`}
                                    ></i>
                                  </button>
                                </div>

                                {isSchemeOpen ? (
                                  <>
                                    <div className="row py-2 px-3">
                                      <div className="col-md-2"></div>
                                      <div className="col-md-2">
                                        <div className="light-green-div bg-success-20">
                                          <span className="fw-500 fs-12px">
                                            Prov. Budget FY{" "}<br/>
                                            <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                                            <br />
                                            <span className="fs-18px text-success-100">
                                              {scheme.provisional_budget.toLocaleString("en-IN")}
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-md-2">
                                        <div className="light-green-div bg-success-20">
                                          <span className="fw-500 fs-12px">
                                            Released Budget FY{" "}<br/>
                                            <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                                          </span>{" "}
                                          <br />
                                          <span className="fs-18px text-success-100">
                                            {scheme.budget.toLocaleString("en-IN")}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-md-2"></div>
                                      <div className="col-md-2">
                                        <div
                                          className="light-green-div"
                                          style={{ backgroundColor: "#28316f" }}
                                        >
                                          <span
                                            className="fw-500 fs-12px"
                                            style={{ color: "#ffffff" }}
                                          >
                                            Expense Budget FY{" "}<br/>
                                            <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                                          </span>{" "}
                                          <br />
                                          <span className="fs-18px" style={{ color: "#ffffff" }}>
                                            {calculateSchemeExpense(scheme).toLocaleString("en-IN")}
                                          </span>
                                        </div>
                                      </div>
                                      <div className="col-md-2">
                                        <div className="light-green-div bg-success-100">
                                          <span
                                            className="fw-500 fs-12px"
                                            style={{ color: "#ffffff" }}
                                          >
                                            Balance FY{" "}<br/>
                                            <span style={{ fontSize: "10px"}}>({moment(e.from_date).format("DD-MM-YYYY")} - {moment(e.to_date).format("DD-MM-YYYY")})</span>
                                            <br />
                                            <span className="fs-18px" style={{ color: "#ffffff" }}>
                                              {(scheme.budget - calculateSchemeExpense(scheme)).toLocaleString(
                                                "en-IN"
                                              )}
                                            </span>
                                          </span>
                                        </div>
                                      </div>
                                    </div>

                                    {/* tabs starts */}
                                    <div className="px-2 m-0">
                                      <div className="border mb-2"></div>
                                      <div className="pb-2 d-flex justify-content-between text-secondary-50 px-4">
                                        <button
                                          onClick={() =>
                                            setActiveSchemeTab((prev) => ({
                                              ...prev,
                                              [schemeKey]: "subhead",
                                            }))
                                          }
                                          className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1 rounded-4 ${
                                            activeSchemeTab[schemeKey] === "subhead"
                                              ? "bg-secondary-20"
                                              : "bg-white"
                                          } `}
                                        >
                                          {activeSchemeTab[schemeKey] === "subhead" ? (
                                            <i className="icon-remove_circle_outline"></i>
                                          ) : (
                                            <i className="icon-add_circle_outline"></i>
                                          )}
                                          Sub head
                                        </button>
                                        {/* <button
                                          onClick={() =>
                                            mainCardSwitch(
                                              `activity_${e.id}`,
                                              `subhead_${e.id}`,
                                              `subactivity_${e.id}`,
                                              {
                                                scheme_id: e.id,
                                                subhead: false,
                                                activity: true,
                                                subActivity: false,
                                              }
                                            )
                                          }
                                          className={`border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4 ${
                                            activeCard.includes(`activity_${e.id}`)
                                              ? "bg-secondary-20"
                                              : "bg-white"
                                          } `}
                                        >
                                          {activeCard.includes(`activity_${e.id}`) ? (
                                            <i className="icon-remove_circle_outline"></i>
                                          ) : (
                                            <i className="icon-add_circle_outline"></i>
                                          )}
                                          Activity
                                        </button> */}
                                        <button
                                          onClick={() =>
                                            setActiveSchemeTab((prev) => ({
                                              ...prev,
                                              [schemeKey]: "subactivity",
                                            }))
                                          }
                                          className={` ${
                                            activeSchemeTab[schemeKey] === "subactivity"
                                              ? "bg-secondary-20"
                                              : "bg-white"
                                          } border-0 text-secondary-50 d-flex align-items-center gap-1 fs-12px text-secondary-50 px-2 py-1  rounded-4`}
                                        >
                                          {activeSchemeTab[schemeKey] === "subactivity" ? (
                                            <i className="icon-remove_circle_outline"></i>
                                          ) : (
                                            <i className="icon-add_circle_outline"></i>
                                          )}
                                          Sub-Activity
                                        </button>
                                      </div>
                                    </div>
                                    {/* tabs ends */}

                                    {activeSchemeTab[schemeKey] === "subhead" ? (
                                    <div className="subhead_card p-1">
                                      <div className="consolidate_ppa_table_wrapper">
                                        <table className="consolidate_ppa_table" border="1">
                                          <tbody>
                                          <tr>
                                            <td
                                              rowspan="3"
                                              style={{ backgroundColor: "#f0f0f0", width: "200px", minWidth: "200px" }}
                                            >
                                              Caption
                                            </td>
                                            <td rowspan="3" style={{ width: "100px", minWidth: "100px" }}>
                                              Provisioned Budget
                                            </td>
                                            <td>1</td>
                                            <td>2</td>
                                            <td>3</td>
                                            <td>4</td>
                                            <td>5(1+2+3+4)</td>
                                            <td>6</td>
                                            <td>7</td>
                                            <td>8</td>
                                            <td>9(6+7+8)</td>
                                            <td>10(5-9)</td>
                                            <td>11</td>
                                            <td>12</td>
                                            <td>13</td>
                                            <td>14(11+12+13)</td>
                                            <td>15</td>
                                            <td>16(14+15)</td>
                                            <td>17(10-16)</td>
                                            <td>18</td>
                                            <td>19</td>
                                          </tr>
                                          <tr>
                                            <td colspan="5">Budget Received</td>
                                            <td colspan="4">Budget Transferred</td>
                                            <td></td>
                                            <td colspan="5">PPA Payment</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                          </tr>
                                          <tr>
                                            <td>Opening Balance</td>
                                            <td>Release Budget</td>
                                            <td>Reappropriation Budget</td>
                                            <td>Surrender Budget</td>
                                            <td>Total Budget</td>
                                            <td>Limit Allocated to child</td>
                                            <td>Reappropriation transferred</td>
                                            <td>Surrender to parent</td>
                                            <td>Total Budget Transferred</td>
                                            <td>Budget / Limit Allowed</td>
                                            <td>Vendor</td>
                                            <td>DBT</td>
                                            <td>Salary</td>
                                            <td>Total Successfully Payment</td>
                                            <td>PPA (Under Approval)</td>
                                            <td>Total Budget</td>
                                            <td>Balance on (Date)</td>
                                            <td>Commulative</td>
                                            <td>Commulative Expenditure</td>
                                          </tr>
                                          {
                                            scheme.sub_head_list.map((subhead, subheadIndex) => {
                                              return (
                                                <tr key={subheadIndex}>
                                                  <td>{subhead.name}</td>
                                                  <td>{subhead.provisional_budget || 0}</td>
                                                  <td>{subhead.openingBalance || 0}</td>
                                                  <td>{subhead.budget || 0}</td>
                                                  <td>{subhead.reappropriate_received || 0}</td>
                                                  <td>{subhead.surrender_received || 0}</td>
                                                  <td>{subhead.openingBalance + subhead.budget + subhead.reappropriate_received + subhead.surrender_received || 0}</td>
                                                  <td>{subhead.allocation || 0}</td>
                                                  <td>{subhead.reappropriate_given || 0}</td>
                                                  <td>{subhead.surrender_given || 0}</td>
                                                  <td>{subhead.allocation + subhead.reappropriate_given + subhead.surrender_given || 0}</td>
                                                  <td>{(subhead.openingBalance + subhead.budget + subhead.reappropriate_received + subhead.surrender_received) - (subhead.allocation + subhead.reappropriate_given + subhead.surrender_given) || 0}</td>
                                                  <td>{subhead.vendor || 0}</td>
                                                  <td>{subhead.dbt || 0}</td>
                                                  <td>{subhead.salary || 0}</td>
                                                  <td>{subhead.vendor + subhead.dbt + subhead.salary || 0}</td>
                                                  <td>{subhead.pendingPPA || 0}</td>
                                                  <td>{subhead.vendor + subhead.dbt + subhead.salary + subhead.pendingPPA || 0}</td>
                                                  <td>{((subhead.openingBalance + subhead.budget + subhead.reappropriate_received + subhead.surrender_received) - (subhead.allocation + subhead.reappropriate_given + subhead.surrender_given)) - (subhead.vendor + subhead.dbt + subhead.salary + subhead.pendingPPA) || 0}</td>
                                                  <td>-</td>
                                                  <td>-</td>
                                                </tr>
                                              )
                                            })
                                          }
                                          </tbody>
                                        </table>
                                      </div>
                                    </div>
                                    ) : null}

                                    {activeSchemeTab[schemeKey] === "subactivity" ? (
                                    <div className="subactivity_card">
                                      <div>
                                        <div className="bg-success-20 d-flex justify-content-between align-items-center p-1 transition overflow-hidden">
                                          {/* ======================card header================== */}
                                          <span
                                            className="fs-14px white-space-nowrap overflow-x-hidden d-flex justify-content-between align-items-center gap-2 p-0 m-0 w-100"
                                            style={{ width: "95%", fontStyle: "italic" }}
                                          >
                                            {/* =======================card header====================== */}
                                            <span
                                              className="fs-12px white-space-nowrap overflow-x-hidden"
                                              style={{ width: "95%", fontStyle: "italic" }}
                                            >
                                              <span className="fw-500 text-success-100">
                                                {schemeName}
                                              </span>
                                            </span>
                                          </span>
                                        </div>
                                        <table border="1" style={{margin: "5px"}}>
                                          <tbody>
                                            <tr>
                                              <td rowspan="3">Provisioned Budget</td>
                                              <td>1</td>
                                              <td>2</td>
                                              <td>3</td>
                                              <td>4</td>
                                              <td>5(1+2+3+4)</td>
                                              <td>6</td>
                                              <td>7</td>
                                              <td>8</td>
                                              <td>9(6+7+8)</td>
                                              <td>10(5-9)</td>
                                              <td>11</td>
                                              <td>12</td>
                                              <td>13</td>
                                              <td>14(11+12+13)</td>
                                              <td>15</td>
                                              <td>16(14+15)</td>
                                              <td>17(10-16)</td>
                                              <td>18</td>
                                              <td>19</td>
                                            </tr>
                                            <tr>
                                              <td colspan="5">Budget Received</td>
                                              <td colspan="4">Budget Transferred</td>
                                              <td></td>
                                              <td colspan="5">PPA Payment</td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                              <td></td>
                                            </tr>
                                            <tr>
                                              <td>Opening Balance</td>
                                              <td>Release Budget</td>
                                              <td>Reappropriation Budget</td>
                                              <td>Surrender Budget</td>
                                              <td>Total Budget</td>
                                              <td>Limit Allocated to child</td>
                                              <td>Reappropriation transferred</td>
                                              <td>Surrender to parent</td>
                                              <td>Total Budget Transferred</td>
                                              <td>Budget / Limit Allowed</td>
                                              <td>Vendor</td>
                                              <td>DBT</td>
                                              <td>Salary</td>
                                              <td>Total Successfully Payment</td>
                                              <td>PPA (Under Approval)</td>
                                              <td>Total Budget</td>
                                              <td>Balance on (Date)</td>
                                              <td>Commulative</td>
                                              <td>Commulative Expenditure</td>
                                            </tr>
                                          </tbody>
                                        </table>
                                      </div>
                                      
                                    </div>
                                    ) : null}

                                    
                                  </>
                                ) : null}
                              </div>
                            );
                          })
                        }
                      </>
                    ) : null}
                    
                  </div>
                  );
                })}
              </div>
            </div>


            <MainFilter 
              open={open} 
              handleClose={handleClose} 
              handleInput={handleInput} 
              handleOpen={handleOpen}
              filterPayload={filterPayload}
              handleFilterClick={handleFilterClick}
              type={"consolidatePPAExpenseReport"}
            />

        </div>
    )
}